import React from 'react';
import { Link } from 'gatsby';
import { isLocal } from '../utils/ensureTrailingSlash';

const DynamicLink = ({ link, children, ...props }) => {
  if (!link) return null;

  return isLocal(link) ? (
    <Link to={link} {...props}>
      {children}
    </Link>
  ) : (
    <a href={link} target="_blank" {...props}>
      {children}
    </a>
  );
};

export default DynamicLink;
